// utils/v3/ids.ts — id helpers (SPEC §6)
import { nanoid } from 'nanoid'

/** Short cart-line id — legacy uses nanoid(8) for CartItem.uuid. */
export const shortId = (): string => nanoid(8)
